import axiosConfig from "./axiosConfig";

export interface ImportMatchReading {
  exportGridConnectionId: string;
  totalMeteredKwh: number;
  sellerName: string;
  tariff: number;
}

export interface ImportInvoicePreviewResponse {
  month: string;
  siteName: string;
  siteId: string;
  currencyCode: string;
  invoiceType: "import";
  electricityPrice: number;
  importMatchReadings: ImportMatchReading[];
  totalElectricalOutputKwh: number;
  electricalPaymentAmount: number;
  otherCharges: number;
  subtotal: number;
  vatRate: number;
  vatAmount: number;
  total: number;
  tenantName: string;
}

const getImportInvoicePreview = async (
  authToken: string,
  siteId: string,
  month: string
): Promise<ImportInvoicePreviewResponse> => {
  const { data } = await axiosConfig.get(
    `/site/${siteId}/import-invoice/preview?month=${encodeURIComponent(month)}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getImportInvoicePreview;
